module.exports = __webpack_public_path__ + "static/media/Motor.678237a8.mp3";